<template>
    <div>
        <event-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :paginationData="filterSet.page"></event-filter-link>
        <event-list-link :listLayout="listLayout" :eventData="List" :paginationData="filterSet.page"></event-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page" :listLength="List.length"></pagination-link>
    </div>

</template>

<script>
import eventUtil from "@/components/event/eventUtil";
import alertMixins from "@/mixins/alertMixins";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import EventFilterLink from "@/components/event/EventFilterLink";
import EventListLink from "@/components/event/EventListLink";
import PaginationLink from "@/components/event/PaginationLink";
import DeleteClass from "@/mixins/deleteClass";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";

const {filterConfig} = eventUtil
export default {
    name: 'EventListComponent',
    mixins: [ eventUtil, alertMixins, filterMixins, listMixins ],
    components: {
        EventFilterLink,
        EventListLink,
        PaginationLink,
    },
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setSort: this.setSort,
            // magazineListDelete: this.runDeleteConfirm,
            magazineListSetData: this.setData,
        }
    },
    inject: [],
    props: {
        eventType: {default: ''},
    },
    data() {
        return{
            filterLayout: '',
            listLayout: '',
            paginationLayout: '',
            getFunc: '',
            pageRow: 10,
            paginationType: 'pagination',
            listApiParamSet: {},
            sortOptions: {},
            startSort: {},
            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteModalName: '',
            keyName: '',

            DeleteClass: null,
        }
    },
    created(){
        this.initConfig();
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        this.getList(true)
        EventBus.$on('getEventList', this.getList)
        EventBus.$on('eventDelete', this.runDelete)
    },
    beforeDestroy() {
        EventBus.$off('getEventList')
        EventBus.$off('eventDelete')
    },
    computed: {
    },
    methods: {
        setData(key, value) {
            this[key] = value;
        },
        initConfig() {
            let config = this.returnEventConfig(this.eventType)
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.pageRow = config.pageRow;
            this.listApiParamSet = config.listApiParamSet
            this.keyName = config.keyName
            this.deleteFunc = config.deleteFunc
            this.deleteApiParamsSet = config.deleteApiParamsSet
            this.deleteSuccessType = config.deleteSuccessType
            this.deleteFailTypes = config.deleteFailTypes;
            this.deleteModalName = config.deleteModalName;
            this.sortOptions = config.sortOptions;
            this.setSortOptions(this.sortOptions)
            let listOptions = {
                url: this.$api.$event[this.getFunc],
                defaultParams: this.listApiParamSet,
            }
            if (config.pageRow && config.pageRow != 10) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }
            this.initList('api', listOptions)

            this.newDeleteClass();
        },

        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$event[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        runDelete(key, moreParams={}) {
            // EventBus.$emit('apiLoading', true);
            console.log('test')
            this.DeleteClass.runDelete(key, moreParams)
        },
        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            if(!util.isEmpty(this.deleteModalName)) {
                this.$modal.hide(this.deleteModalName);
            }
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.getList()
                }
            })
        },
    },
    watch: {
    },
}
</script>
